export default __webpack_public_path__ + "img/uvelina-logo.d3e57d623d7960bda5aad99226c80a9b.svg";